import * as React from "react";

interface YAxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: number | string };
  /** Material id when this section has an active line hover; used only for null vs non-null (opacity). */
  hoveredMaterial: number | null;
}

export const YAxisTick: React.FC<YAxisTickProps> = ({
  x,
  y,
  payload,
  hoveredMaterial,
}) => {
  if (!payload || x == null || y == null) {
    return null;
  }
  const hasHover = hoveredMaterial !== null;
  const opacity = hasHover ? 0.25 : 1;
  return (
    <text
      x={x}
      y={y}
      fill="var(--neutral-3)"
      fontSize="0.75rem"
      textAnchor="end"
      style={{ opacity }}
    >
      {payload.value}
    </text>
  );
};
